module.exports = __webpack_public_path__ + "static/media/logo.ed61dc5c.svg";